module.exports = __webpack_public_path__ + "static/media/download.ca49b321.svg";